<template>
    <v-dialog v-model="toggle" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>{{text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#EA6254" text @click="closeDialog">{{rejectButtonText}}</v-btn>
          <v-btn color="#00457C" text @click="dialogAction">{{acceptButtonText}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {

    data() {
        return{

        }
    },

    //toggle is a variable (set in the parent component that uses this dialog component) that toggles display of the dialog when set to true/false.
    props: ['title', 'text', 'rejectButtonText', 'acceptButtonText', 'toggle'],

    methods: {
        
        dialogAction() {
            this.$emit('accept'); //@accept handles event that user accepts dialog's action
        },

        closeDialog() {
            this.$emit('reject'); //@reject handles event that user rejects dialog's action
        }
    
    }
    
}
</script>

<style scoped>

.v-dialog > .v-card > .v-card__title.headline, .v-dialog > .v-card > .v-card__text{
    font-family: Helvetica, Arial, sans-serif !important;
}




</style>